import { render, staticRenderFns } from "./BlockType28.vue?vue&type=template&id=6c901034&scoped=true"
import script from "./BlockType28.vue?vue&type=script&lang=ts"
export * from "./BlockType28.vue?vue&type=script&lang=ts"
import style0 from "./BlockType28.vue?vue&type=style&index=0&id=6c901034&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c901034",
  null
  
)

export default component.exports